export class MigrationProtocolsGrid {
  static readonly Columns = [
    // "id",
    "title",
    "sponsor_protocol_id",
    "iris_protocol_id",
    "status",
    "irb_approval_dt_local",
    //"irb_approval_expiry_dt",
    "irb_closure_dt_local",
    //"review_board",
    "createdOnLocal",
    //"created_by",
    //"is_active",
    //"is_deleted",
    //"migration_status",
    "has_irbnet_sites",
  ];
  static readonly Headers = [
    // "Id",
    "Study Title",
    "Sponsor Protocol Id",
    "WCG Tracking Id",
    "Status",
    "IRB Approval",
    //"IRB Approval Expiry",
    "IRB Closure",
    //"ReviewBoard",
    "Created Date",
    //"Created By",
    //"active",
    //"Deleted",
    //"Migration Status",
    "IrbNet",
  ];
  static readonly Widths = ["*", "140", "120", "*", "150", "150", "150", "*"];
}

class MigrationsGrid {
  static readonly Columns = [
    "id",
    "company_id",
    "company_name",
    "created_by",
    "created_dt_local",
    "progressPercentageLabel",
    "durationText",
    "status",
  ];
  static readonly Headers = [
    "Id",
    "Company Id",
    "Company Name",
    "Created By",
    "Created On",
    "Progress",
    "Duration",
    "Status",
  ];
}
class DeletedMigrationsGrid {
  static readonly Columns = [
    "id",
    "company_id",
    "company_name",
    "created_by",
    "created_dt_local",
    "progressPercentageLabel",
    "status",
  ];
  static readonly Headers = [
    "Id",
    "Company Id",
    "Company Name",
    "Created By",
    "Created On",
    "Progress",
    "Status",
  ];
}

class MigrationStatisticsGrid {
  static readonly Columns = [
    "name",
    "protocol_id",
    "status",
    "started",
    "ended",
    "durationText",
    "description",
  ];

  static readonly Headers = [
    "Name",
    "Protocol Id",
    "Status",
    "Started",
    "Ended",
    "Duration",
    "Details",
  ];

  static readonly Widths = ["*", "80", "120", "160", "160", "70", "250"];
}

export default class GridsConfig {
  static readonly MigrationProtocol = MigrationProtocolsGrid;
  static readonly Migrations = MigrationsGrid;
  static readonly DeletedMigrations = DeletedMigrationsGrid;
  static readonly MigrationStatistics = MigrationStatisticsGrid;
}
